import {
  Box,
  Button,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  CssBaseline,
} from "@mui/material";
import React, { forwardRef, useEffect, useImperativeHandle, useRef, useState } from "react";
import reportslogo from "../../assets/images/reportslogo.png";
import { useReactToPrint } from "react-to-print";
import jsPDF from "jspdf";
import { getAuthToken, getFacilityId } from "../../utility/tokenUtility";
import { ThemeProvider as MuiThemeProvider } from "@mui/material/styles";
import { defaultLightTheme } from "../../assets/styled-components/themes/themelist";
import { useSelector } from "react-redux";
import "jspdf-autotable";
import { useAccess } from "../../AccessContext";
import utilities from '../../utility/utilities';
// import "../commoncomponents/print.css"; 

const Stockdownloadfile = forwardRef(
  ({ setOpenModal, reportdata, onRenderComplete, setIsView, hospitalname, service }, ref) => {
    const [columns, setColumns] = useState([
      "Hospital Name",
      "Item Code",
      "Item Description",
      "UOM",
      "Item Type",
      "Minimum",
      "Maximum",
      "Stock Balance"
    ]); // Set default column names

    const printRef = useRef(null);
    const { color } = useSelector((state) => state.theme);
    const token = getAuthToken("id_token");
    const facilityId = getFacilityId("facilityId");

    const accessData = useAccess();
    const access = utilities.getScreenPermissions(accessData, "STRA001");

    const handlePrint = useReactToPrint({
      content: () => printRef.current,

    });
    //  const handleDownloadPDF = () => {
    //   const input = printRef.current;

    //   const options = {
    //     margin: [0.5, 0.5, 0.5, 0.5],
    //     filename: 'Stock Analysis Report.pdf',
    //     image: { type: 'jpeg', quality: 0.98 },
    //     html2canvas: {
    //       scale: 3,
    //       useCORS: true,
    //       scrollX: 0,
    //       scrollY: 0,
    //       windowWidth: input.scrollWidth,
    //       windowHeight: input.scrollHeight,
    //     },
    //     jsPDF: {
    //       unit: 'in',
    //       format: 'a4',
    //       orientation: 'landscape',
    //     },
    //     pagebreak: {
    //       mode: ['avoid-all', 'css', 'legacy'],
    //       avoid: ['tr', 'td', 'th', '.no-break'],
    //     },
    //   };

    //   html2pdf()
    //     .from(input)
    //     .set(options)
    //     .toPdf()
    //     .get('pdf')
    //     .then((pdf) => {
    //       const totalPages = pdf.internal.getNumberOfPages();
    //       for (let i = 1; i <= totalPages; i++) {
    //         pdf.setPage(i);
    //         pdf.setFontSize(10);
    //         pdf.text(
    //           `Page ${i} of ${totalPages}`,
    //           pdf.internal.pageSize.getWidth() - 1,
    //           pdf.internal.pageSize.getHeight() - 0.5
    //         );
    //       }
    //     })
    //     .save()
    //     .catch((error) => {
    //       console.error('Error generating PDF:', error);
    //     });
    // };
    const handleDownloadPDF = () => {
      const pdf = new jsPDF({
        orientation: 'landscape',
        unit: 'mm',
        format: 'a4',
      });

      const columns = [
        { header: "Hospital Name", dataKey: "hospitalname" },
        { header: "Item Code", dataKey: "itemcode" },
        { header: "Item Description", dataKey: "itemDescription" },
        { header: "UOM", dataKey: "uom" },
        { header: "Item Type", dataKey: "itemType" },
        {
          header: "Minimum",
          dataKey: "minimumstock",
          minWidth: 300,
          cellStyle: { textAlign: "center" },
        },
        {
          header: "Maximum",
          dataKey: "maximumstock",
          minWidth: 300,
          cellStyle: { textAlign: "right" },
        },
        {
          header: "Stock Balance",
          dataKey: "currentstocklevel",
          minWidth: 300,
          cellStyle: { textAlign: "right" },
        },
      ];

      const rows = reportdata.map((row) => ({
        hospitalname: row.hospitalname,
        itemcode: row.itemcode,
        itemDescription: row.itemDescription,
        uom: row.masimsstockregisters && row.masimsstockregisters.length > 0
          ? row.masimsstockregisters[0].remarks
          : "",
        itemType: row.itemType,
        minimumstock: row.minimumstock,
        maximumstock: row.maximumstock,
        currentstocklevel: row.masimsstockregisters && row.masimsstockregisters.length > 0
          ? row.masimsstockregisters[0].currentstocklevel
          : "",
      }));
      const logoWidth = 20; // Adjust the width of the logo as needed
      const logoHeight = 20; // Adjust the height of the logo as needed

      pdf.autoTable({
        head: [columns.map(col => col.header)],
        body: rows.map(row => Object.values(row)),
        startY: 40,
        tableWidth: 'auto',
        theme: "grid",
        headStyles: { background: '#009999', textColor: "white" },
        styles: {
          fontSize: 10,
          minCellHeight: 7,
          cellPadding: 5,
        },
        margin: { top: 30, left: 10, right: 10 },
        columnStyles: {
          5: { halign: 'right' },
          6: { halign: 'right' },
          7: { halign: 'right' },
        },
        didDrawPage: (data) => {
          const pageWidth = pdf.internal.pageSize.width;
          pdf.addImage(reportslogo, 'PNG', 10, 5, logoWidth, logoHeight);
          pdf.setFontSize(12);
          pdf.text(hospitalname?.label || "", pageWidth / 2, 22, { align: "center" });
          pdf.setFont("helvetica", "bold");
          pdf.setFontSize(12);
          pdf.text("Stock Analysis Report", pageWidth / 2, 10, { align: "center" });
          pdf.setFont("helvetica", "bold");
          pdf.setFontSize(12);
          pdf.text(`(${service})`, pageWidth / 2, 16, { align: "center" });
          pdf.setFont("helvetica", "bold");
          const pageCount = pdf.internal.getNumberOfPages();
          pdf.setFontSize(10);
          pdf.text(`Page ${data.pageNumber} of ${pageCount}`, pageWidth - 30, pdf.internal.pageSize.height - 10);
        },
      });

      pdf.save("Stock Analysis Report.pdf");
    };


    const handleClose = () => {
      setIsView(false);
      setOpenModal(false);
    };

    useImperativeHandle(ref, () => ({
      handleDownloadPDF,

    }));
    const addFooter = (pdf, pageNumber, pageWidth, pageHeight, margin) => {
      const footerText = `Page ${pageNumber}`;
      const footerFontSize = 10; // Font size for footer

      // Set font and size for the footer
      pdf.setFontSize(footerFontSize);
      pdf.text(footerText, pageWidth - margin - 20, pageHeight - margin); // Position the text
    };
    useEffect(() => {
      if (onRenderComplete) {
        onRenderComplete();
      }
    }, [onRenderComplete]);

    return (
      <MuiThemeProvider
        theme={{
          ...defaultLightTheme,
          palette: {
            ...defaultLightTheme.palette,
            background: {
              default: color !== "default" ? "rgba(17, 17, 17, 1)" : defaultLightTheme.palette.background.default,
            },
          },
        }}
      >
        <CssBaseline />
        <Stack direction="row" justifyContent="end" alignItems="center" gap={2} mt={2}>
          {access?.canPrint && (<>
            <Button variant="contained" sx={{ backgroundColor: "#A77BCA" }} onClick={handlePrint} data-testid="print">
              Print
            </Button>
            <Button variant="contained" onClick={handleDownloadPDF}>
              Download
            </Button>
          </>)}
          <Button variant="contained" onClick={handleClose}>
            Close
          </Button>
        </Stack>

        <TableContainer ref={printRef} style={{ width: '1000px' }}>
          <Table>

            {/* Header Row */}
            <TableRow>
              <TableCell colSpan={columns.length} align="left" style={{ border: 'none' }}>
                <img src={reportslogo} alt="logo" width="8%" />
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell colSpan={columns.length} align="center" style={{ fontSize: '25px', fontFamily: 'Arial Narrow', fontWeight: 'bold', border: 'none' }}>
                {hospitalname?.label}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell colSpan={columns.length} align="center" style={{ fontSize: '23px', fontFamily: 'Arial Narrow', fontWeight: 'bold', border: 'none' }}>
                Stock Analysis Report
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell colSpan={columns.length} align="center" style={{ fontSize: '23px', fontFamily: 'Arial Narrow', fontWeight: 'bold', border: 'none' }}>
                ({service})
              </TableCell>
            </TableRow>

            <TableBody>
              {/* Table Column Headers */}
              <TableRow style={{ backgroundColor: '#009999' }}>
                {columns.map((header, index) => (
                  <TableCell key={index} style={{ fontWeight: 'bold', color: 'white', textAlign: 'center' }}>
                    {header}
                  </TableCell>
                ))}
              </TableRow>

              {/* Table Rows */}
              {reportdata && reportdata.length > 0 ? (
                reportdata.map((row, rowIndex) => (
                  <TableRow key={rowIndex}>
                    <TableCell style={{ textAlign: 'center' }}>{row.hospitalname}</TableCell>
                    <TableCell style={{ textAlign: 'center' }}>{row.itemcode}</TableCell>
                    <TableCell style={{ textAlign: 'center' }}>{row.itemDescription}</TableCell>
                    <TableCell style={{ textAlign: 'center' }}>
                      {row.masimsstockregisters?.length > 0 ? row.masimsstockregisters[0].remarks : ''}
                    </TableCell>
                    <TableCell style={{ textAlign: 'center' }}>{row.itemType}</TableCell>
                    <TableCell style={{ textAlign: 'right' }}>{row.minimumstock}</TableCell>
                    <TableCell style={{ textAlign: 'right' }}>{row.maximumstock}</TableCell>
                    <TableCell style={{ textAlign: 'right' }}>
                      {row.masimsstockregisters?.length > 0 ? row.masimsstockregisters[0].currentstocklevel : ''}
                    </TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={columns.length} style={{ textAlign: 'center' }}>
                    <Typography>No Records Found</Typography>
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>

      </MuiThemeProvider>
    );
  }
);

export default Stockdownloadfile;
